import * as React from 'react';
import { GridRowsImage } from './components/GridRowsImage';

export const NoRowsOverlay = () => {
  return <GridRowsImage label="No Rows" />;
};
